import { SET_SEARCH_STRING } from './constants'

export default searchValue => dispatch => {
    dispatch({
        type: SET_SEARCH_STRING,
        payload: searchValue,
    })
}
